import React from "react";
import styled from "styled-components";

const ToggleContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  &.whistle-settings {
    width: 30px;
    height: 15px;
  }
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  span {
    box-shadow: 0 0 1px #2196f3;
  }
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e7f2f9;
  transition: 0.4s;
  box-shadow: 0 0 1px #2196f3;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    background-color: red;
  }

  ${ToggleInput}:checked + &::before {
    transform: translateX(26px);
    background-color: green;
  }

  &.whistle-settings {
    background-color: #f0f0f0; /* example: change background */
    border-radius: 15px; /* example: change border radius */
  }

  &.whistle-settings:before {
    height: 12px;
    width: 12px;
    left: 2px;
    bottom: 2px;
    background-color: #2196f3;
  }

  ${ToggleInput}:checked + &.whistle-settings:before {
    transform: translateX(14px); /* move less for smaller toggle */
    background-color: #4caf50; /* example: change color when checked */
  }
`;

const OnOffToggle = ({ on, handleToggle, page="" }) => {
  return (
    <ToggleContainer className={page}>
      <ToggleInput
      className={page}
        type="checkbox"
        checked={on}
        onChange={() => {
          handleToggle();
        }}
      />
      <ToggleSlider className={page} />
    </ToggleContainer>
  );
};

export default OnOffToggle;
